module.exports = __webpack_public_path__ + "img/loader_white.db66649c.svg";